const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

export interface QuoteData {
  service: string;
  layout: string;
  photoUrl?: string;
  zip: string;
  name: string;
  phone: string;
  email: string;
  referralUrl?: string;
}

export interface QuoteResponse {
  success: boolean;
  ticketId: string;
}

export interface UploadResponse {
  success: boolean;
  fileName: string;
  url: string;
}

export async function submitQuote(data: QuoteData): Promise<QuoteResponse> {
  console.log('Submitting quote to:', `${API_URL}/api/quote`);

  const response = await fetch(`${API_URL}/api/quote`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  console.log('Response status:', response.status);

  if (!response.ok) {
    const errorText = await response.text();
    console.error('Quote submission failed:', errorText);
    throw new Error(`Failed to submit quote: ${response.status} ${errorText}`);
  }

  return response.json();
}

export async function uploadImage(file: File): Promise<UploadResponse> {
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(`${API_URL}/api/upload`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Failed to upload image');
  }

  return response.json();
}
